import { ICopyObraUseCase } from "../../../presentation/useCases/create/copy_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CopyObraUseCase
 */

export class CopyObraUseCase implements ICopyObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async copyObra(
    idObra: number,
    idCentroCusto: number,
    copiarChecklist: number,
  ): Promise<void> {
    await this.repository.copyObra(
      idObra,
      idCentroCusto,
      copiarChecklist,
    );
  }
}
